import { render } from "./InventorieCreate.vue?vue&type=template&id=444daf72&scoped=true"
import script from "./InventorieCreate.vue?vue&type=script&lang=js"
export * from "./InventorieCreate.vue?vue&type=script&lang=js"

import "./InventorieCreate.vue?vue&type=style&index=0&id=444daf72&scoped=true&lang=css"

import exportComponent from "C:\\frotend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-444daf72"]])

export default __exports__